/* @flow */

export const xsmall = Symbol();
export const small = Symbol();
export const medium = Symbol();
export const large = Symbol();
export const xlarge = Symbol();
export const xxlarge = Symbol();
